<article appContextualmenu [contextMenuParams]="{items: this.context()}"
  class="w-full h-16 bg-transparent hover:bg-zinc-500/[.05] transition-colors p-2 rounded-lg sm:grid gap-2 cursor-pointer flex justify-center">
  <div class="w-[50px] h-[50px] relative overflow-hidden" [ngClass]="this.object.item.type==='artist'?'rounded-full':'rounded-md'">
      @if(this.object.item.image!==''){
        <img class="object-cover" [ngSrc]="this.object.item.image ?? ''" srcset="" [alt]="this.object.item.type +' '+ this.object.item.title " priority fill style="height: fit-content;width: 100%;">
      }@else {
        <div class="w-[50px] h-[50px] rounded-md bg-zinc-600/40 p-3"><svg data-encore-id="icon" role="img" aria-hidden="true" data-testid="playlist" class="fill-neutral-400" viewBox="0 0 24 24"><path d="M6 3h15v15.167a3.5 3.5 0 1 1-3.5-3.5H19V5H8v13.167a3.5 3.5 0 1 1-3.5-3.5H6V3zm0 13.667H4.5a1.5 1.5 0 1 0 1.5 1.5v-1.5zm13 0h-1.5a1.5 1.5 0 1 0 1.5 1.5v-1.5z"></path></svg></div>
      }
  </div>
  <div class="sm:flex mt-1 hidden relative select-none">
    <div class="flex flex-col absolute max-w-full overflow-hidden whitespace-nowrap">
      <p class="text-base text-white text-ellipsis ">{{this.object.item.title}}</p>
      <p class="text-sm text-gray-300/80 text-ellipsis">{{this.object | getDisplayName: dictionary}}</p>
    </div>
  </div>
</article>
